import { DetailSummary } from "@/shared/components/ui/DetailSummary";
import type { StripeFinanceTotals } from "../types/stripeTypes";
import { formatStripeMinorAmount } from "../utils/stripeMoney";

export function StripeFinanceTotalsSummary({ totals }: { totals: StripeFinanceTotals }) {
  return (
    <DetailSummary items={[
      { label: "Gross income", value: formatStripeMinorAmount(totals.grossMinor, totals.currency) },
      { label: "Net income", value: formatStripeMinorAmount(totals.netMinor, totals.currency) },
      { label: "Paid out", value: formatStripeMinorAmount(totals.paidOutMinor, totals.currency) },
    ]} />
  );
}
